/**
 * Navigation menu reference — the single source of truth mapping every menu
 * entry to its **page id**, **slug**, and **page name**. Generated from the
 * `menuData` variable declared in the raw design layout shells
 * (RawHTMLDesign/layouts/*.html) and cross-referenced with the page folders in
 * RawHTMLDesign/PageDesignMap.json for slugs.
 *
 * The app navigates by **slug** (never by page id). Each layout drives its nav
 * from this file, and route registration in App.jsx keys routes on `slug`.
 * Until a page's real component exists, its slug-based route falls through to
 * the 404 catch-all; ui-components-from-reference registers the real route when
 * the page is generated.
 */

export const menuData = {
  children: [
    {
      label: 'Module Registry',
      pageId: 73011,
      slug: 'module-composer',
      icon: 'fa fa-archive',
      children: null,
    },
    {
      label: 'Assessment Center',
      pageId: 73007,
      slug: 'assessment-center',
      icon: 'fa fa-pen-square',
      children: null,
    },
    {
      label: 'Learner Dashboard',
      pageId: null,
      slug: null,
      icon: 'fa fa-gauge',
      children: [
        {
          label: 'Course Player',
          pageId: 73004,
          slug: 'course-player',
          icon: 'fa fa-play-circle',
          children: null,
        },
        {
          label: 'Graduate Job Board',
          pageId: 73029,
          slug: 'graduate-job-board',
          icon: 'fa fa-briefcase',
          children: null,
        },
      ],
    },
    {
      label: 'Course Catalogue',
      pageId: 73015,
      slug: 'course-catalogue',
      icon: 'fa fa-book',
      children: null,
    },
    {
      label: 'Employer Portal',
      pageId: 73026,
      slug: 'employer-operations-workspace',
      icon: 'fa fa-building',
      children: null,
    },
    {
      label: 'Academy Console',
      pageId: null,
      slug: null,
      icon: 'fa fa-gears',
      children: [
        {
          label: 'Operations Console',
          pageId: 73019,
          slug: 'academy-operations-console',
          icon: 'fa fa-gauge-high',
          children: null,
        },
        {
          label: 'Job Board Moderation',
          pageId: 73027,
          slug: 'job-board-moderation-console',
          icon: 'fa fa-gavel',
          children: null,
        },
        {
          label: 'Learner Management Agent',
          pageId: 73030,
          slug: 'learner-management-agent-dashboard',
          icon: 'fa fa-user-doctor',
          children: null,
        },
        {
          label: 'Coupons & Payments',
          pageId: 73020,
          slug: 'coupon-payment-admin-console',
          icon: 'fa fa-credit-card',
          children: null,
        },
        {
          label: 'Platform Settings',
          pageId: 73031,
          slug: 'platform-settings',
          icon: 'fa fa-gear',
          children: null,
        },
      ],
    },
    {
      label: 'Course Studio',
      pageId: null,
      slug: null,
      icon: 'fa fa-wand-magic-sparkles',
      children: [
        {
          label: 'Academic Design Agent',
          pageId: 73028,
          slug: 'academic-design-agent-console',
          icon: 'fa fa-list-check',
          children: null,
        },
      ],
    },
    {
      label: 'Verify Credential',
      pageId: 73013,
      slug: 'credential-verification-portal',
      icon: 'fa fa-circle-check',
      children: null,
    },

  ],
  defaultMenuItem: {
    label: 'Course Catalogue',
    pageId: 73015,
    slug: 'course-catalogue',
    icon: 'fa fa-book',
    children: null,
  },
};

/**
 * The set of slugs that currently resolve to a real generated page. As
 * ui-components-from-reference generates each page it should add the page's
 * slug here so the nav links to the real route instead of the 404 fallback.
 * Empty until pages are generated.
 */
export const registeredSlugs = new Set([
  'platform-settings',
  'forgot-password',
  'reset-password',
  'oauth-complete',
  'course-catalogue',
  'registration-profile',
  'learner-dashboard',
  'intake-assessment-form',
  'cohort-enrollment-contract',
  'checkout-enrollment-payment',
  'course-player',
  'assessment-center',
  'academy-operations-console',
  'certificate-web-view-badge',
  'credential-verification-portal',
  'sandbox-capstone-player',
  'graduate-job-board',
  'expert-openings',
  'course-workspace',
  'course-intent-capture',
  'module-composer',
  'external-modules-manager',
  'roles-permissions-approvals-dashboard',
  'certification-criteria-manager',
  'graduate-record-administrator',
  'coupon-payment-admin-console',
  'job-board-moderation-console',
  'employer-operations-workspace',
  'role-landing-hub',
  'cohort-communications-announcements',
  'academic-design-agent-console',
  'learner-feedback-insights-workspace',
  'learner-management-agent-dashboard',
]);

export default menuData;
